module.exports = __webpack_public_path__ + "assets/nvshengjie.3766d586.svg";